import { colors } from '@components/3rd-party/themes'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TabViewConf } from '@constants'
import styled from 'styled-components'
import * as css from './StandardTabBar.css'

interface IStandardTabProps {
  tabList: Array<TabViewConf>
  selectedTabValue: string
  onTabChangeHandler?: Function
}

const StyledTabs = styled(Tabs)(props => ({
  '&&': {
    flex: '0 0 auto',
    minHeight: 32,
    borderBottom: 'solid 1px var(--background-grey-5)'
  }
}))

const StyledTab = styled(Tab)(props => ({
  '&&': {
    textTransform: 'uppercase',
    minWidth: 40,
    minHeight: 30,
    paddingLeft: 0,
    paddingRight: 0,
    font: 'var(--typography-body1)',
    letterSpacing: '0.14px',
    color: 'var(--black)',
    margin: '0 18px 0 0px',
    '& span': {
      padding: '0',
      '> span': {
        padding: '0 0 10px 0'
      }
    },
    '&:hover': {
      color: colors.darkgrey,
      opacity: 1
    }
  }
}))

export const StandardTab: React.FunctionComponent<IStandardTabProps> = ({
  tabList,
  selectedTabValue,
  onTabChangeHandler
}) => {
  const { t } = useTranslation()
  return (
    <StyledTabs
      value={selectedTabValue}
      onChange={(e, v) => onTabChangeHandler!(v)}
      classes={{ indicator: css.tabsIndicator }}
      TabIndicatorProps={{ children: <div /> }}
    >
      {tabList.map((item, i) => (
        <StyledTab
          key={i}
          disableRipple
          label={
            item.translationKey
              ? t(`bb.listview.tabs.${item.translationKey}`, item.name)
              : item.name
          }
          value={item.name}
          classes={{ selected: css.tabSelected }}
        />
      ))}
    </StyledTabs>
  )
}
